<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
  <component
    :is="tag"
    v-if="text"
    :class="['orangehrm-buzz-post-text', textClass]"
  >
    <template v-for="(segment, index) in segments" :key="index">
      <span v-if="segment.type === 'text'">{{ segment.value }}</span
      ><span
        v-else-if="segment.type === 'mention'"
        class="orangehrm-buzz-mention"
        role="link"
        tabindex="0"
        @click="onMentionClick(segment.empNumber)"
        @keydown.enter="onMentionClick(segment.empNumber)"
        >@{{ segment.value }}</span
      ><a
        v-else-if="segment.type === 'link'"
        class="orangehrm-buzz-link"
        :href="segment.href"
        target="_blank"
        rel="noopener noreferrer"
        @click.stop
        >{{ segment.value }}</a
      >
    </template>
  </component>
</template>

<script>
import {computed} from 'vue';
import useBuzzEmployeeMentionDialog from '@/orangehrmBuzzPlugin/util/composable/useBuzzEmployeeMentionDialog';
import {parseBuzzMentionText} from '@/orangehrmBuzzPlugin/util/formatBuzzMentions';

export default {
  name: 'BuzzPostText',

  props: {
    text: {
      type: String,
      default: '',
    },
    tag: {
      type: String,
      default: 'span',
    },
    textClass: {
      type: [String, Object, Array],
      default: null,
    },
  },

  setup(props) {
    const {openEmployeeMention} = useBuzzEmployeeMentionDialog();
    const segments = computed(() => parseBuzzMentionText(props.text ?? ''));

    const onMentionClick = (empNumber) => {
      if (!empNumber) {
        return;
      }
      openEmployeeMention(empNumber);
    };

    return {
      segments,
      onMentionClick,
    };
  },
};
</script>

<style lang="scss" scoped src="./buzz-employee-link.scss"></style>

<style lang="scss" scoped>
.orangehrm-buzz-post-text {
  font-family: $oxd-font-family;
  margin: 0;
  color: $oxd-interface-gray-darken-1-color;
  overflow-wrap: break-word;
}

.orangehrm-buzz-link {
  color: $oxd-primary-one-color;
  text-decoration: none;
  word-break: break-all;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
}
</style>
